import { Component, Input, OnInit } from '@angular/core';
import { IMAGE_SRC } from 'src/app/components/shared/shared-constants';
import { HEADER, INDICATORS } from './indicators-card.constants';

@Component({
  selector: 'app-indicators-card',
  templateUrl: './indicators-card.component.html',
  styleUrls: ['./indicators-card.component.scss'],
  standalone: false,
})
export class IndicatorsCardComponent implements OnInit {
  @Input() indicatorData!: boolean[];
  dataRows: boolean[][] = [];
  readonly HEADER = HEADER;
  readonly INDICATORS = INDICATORS;
  readonly IMAGES = IMAGE_SRC;

  ngOnInit(): void {
    this.dataRows.push(this.indicatorData.slice(0, 5));
    this.dataRows.push(this.indicatorData.slice(5, 10));
    this.dataRows.push(this.indicatorData.slice(10, 15));
  }
}
